import { toast, Bounce, Flip } from "react-toastify";

let errorDisplayedForPage = false;
let currentPath = window.location.pathname;

const checkAndResetErrorFlag = () => {
  const newPath = window.location.pathname; 
  if (newPath !== currentPath) {
    errorDisplayedForPage = false;
    currentPath = newPath;
  }
};

window.addEventListener("popstate", checkAndResetErrorFlag);
window.addEventListener("pushstate", checkAndResetErrorFlag); 
window.addEventListener("replacestate", checkAndResetErrorFlag); 


export const errorMsg = (message) => {
  checkAndResetErrorFlag(); 
  if (!errorDisplayedForPage) {
    toast.error(message, { transition: Bounce });
    errorDisplayedForPage = true;
  }
};

export const successMsg = (message) => {
  toast.success(message, { transition: Flip });
};

export const resetErrorFlag = () => {
  errorDisplayedForPage = false;
};

